import { fetchWithAuth } from '../helpers';

const getAll = async (params: { page: number; limit: number; search?: string; level?: string; grade?: string; is_ielts?: string; is_toeic?: string }) => {
  const queryParams = new URLSearchParams({
    page: params.page.toString(),
    limit: params.limit.toString(),
  });

  if (params.search) queryParams.append('search', params.search);
  if (params.level) queryParams.append('level', params.level);
  if (params.grade) queryParams.append('grade', params.grade);
  if (params.is_ielts) queryParams.append('is_ielts', params.is_ielts);
  if (params.is_toeic) queryParams.append('is_toeic', params.is_toeic);

  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/vocabulary?${queryParams.toString()}`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const getStats = async () => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/vocabulary/stats`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const getById = async (id: number) => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/vocabulary/${id}`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const getByWord = async (word: string) => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/vocabulary/word/${word}`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const create = (vocabulary: any) => {
  return fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/vocabulary`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      "ngrok-skip-browser-warning": "69420" 
    },
    body: JSON.stringify(vocabulary)
  })
    .then(handleResponse);
};

const update = (id: number, vocabulary: any) => {
  return fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/vocabulary/${id}`, {
    method: 'PUT',
    headers: { 
      'Content-Type': 'application/json',
      "ngrok-skip-browser-warning": "69420" 
    },
    body: JSON.stringify(vocabulary)
  })
    .then(handleResponse);
};

const remove = (id: number) => {
  return fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/vocabulary/${id}`, {
    method: 'DELETE',
    headers: { "ngrok-skip-browser-warning": "69420" }
  })
    .then(handleResponse);
};

const search = async (query: string) => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/vocabulary/search?q=${encodeURIComponent(query)}`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const translate = async (text: string) => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/vocabulary/translate`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      "ngrok-skip-browser-warning": "69420" 
    },
    body: JSON.stringify({ text })
  });
  return handleResponse(response);
};

function handleResponse(response: Response) {
  return response.text().then((text: string) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}

export const vocabularyService = {
  getAll,
  getStats,
  getById,
  getByWord,
  create,
  update,
  remove,
  search,
  translate,
};
